import { useContext, useState } from 'react';
import { AppContext } from '../../../bootstrap/App';
import User from '../../../models/User';
import useEventsApiClient from '../../../helper/useEventsApiClient';
import useLogEvent, { LogLevel } from '../../../helper/useLogEvent';
import { StatusCodes } from 'http-status-codes';
import CustomUserData from '../models/CustomUserData';

interface Response extends User {}

/**
 * Update the custom data of the current signed-in user
 */
function useSetCurrentUserData() {
  const [loading, setLoading] = useState(false);

  const { setUser } = useContext(AppContext);
  const { logEvent } = useLogEvent();
  const { apiClient } = useEventsApiClient();

  const setData = async (data: Partial<CustomUserData>) => {
    try {
      setLoading(true);

      // Call the API to update user info
      const response = await apiClient.put<Response>('users/me', data);

      if (response.status !== StatusCodes.OK) {
        throw new Error('Unable to update user data');
      }

      setLoading(false);

      logEvent(LogLevel.Info, 'Update user data', {
        user: response.data,
      });

      setUser({ ...response.data });

      setLoading(false);
    } catch (error) {
      logEvent(LogLevel.Info, 'Fail to update user data');
      setLoading(false);
      throw error;
    }
  };

  return { setData, loading };
}

export default useSetCurrentUserData;
